import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import { Row } from 'antd';
import { type ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import BubbleComponent from '../components/bubble';
import Link from '../components/link';
import PropertyAdd from '../components/property/add';
import Table from '../components/table';
import { getColumnSearch } from '../fragments/table-get-column-search';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import { propertiesLoad } from '../reducers/properties/reducer';

interface DataType {
  key: string;
  code: string;
}

function PropertiesContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const propertiesCodes = useSelector((s: RootState) => s.Properties.codes);
  const propertiesInProcess = useSelector(
    (s: RootState) => s.Properties.inProcess,
  );

  const [dataSource, setDataSource] = useState<DataType[]>([]);
  const [columns, setColumns] = useState<ColumnsType<object>>([]);

  useEffect((): void => {
    dispatch(propertiesLoad());
  }, [dispatch]);

  useEffect((): void => {
    const dataSourceUE: DataType[] = propertiesCodes.map(
      (code: string): DataType => ({
        key: code,
        code,
      }),
    );

    const columnsUE: ColumnsType<object> = [
      {
        title: 'Code',
        dataIndex: 'code',
        sorter: (a: DataType, b: DataType): number =>
          stringCompare(a.code, b.code),
        filterSearch: true,
        render: (text: string, record: DataType): React.ReactElement => (
          <Link to={`/property/${record.code}`} label={text} openInNewTab />
        ),
        ...getColumnSearch('code'),
      },
    ];

    setDataSource(dataSourceUE);
    setColumns(columnsUE);
  }, [propertiesCodes, propertiesCodes.length]);

  return (
    <>
      <Row>
        <BubbleComponent span={8}>
          <PropertyAdd />
        </BubbleComponent>
      </Row>

      <Table
        columns={columns}
        dataSource={dataSource}
        isLoading={propertiesInProcess && propertiesCodes.length === 0}
        emptyText="No properties found"
      />
    </>
  );
}

export default PropertiesContainer;
